import React, { useCallback, useEffect, useState } from 'react';
import Cell from '../widgets/Cell';
import useMyFormState from '../../hooks/useMyFormState';
import { isValidEmail, isValidUsername } from '../../hooks/useValidation';
import Tbl from '../widgets/Tbl';
import TblHdr from '../widgets/TblHdr';
import TblRow from '../widgets/TblRow';
import TblCell from '../widgets/TblCell';
import FormButton from '../widgets/FormButton';
import './TestoRama.css';

// export const isValidUsername = (aUserName, isMandatory = false) => {
//   if (aUserName) {
//     return validator.matches(aUserName, /^[a-zA-Z0-9_@+.-]{10,32}$/);
//   }

//   return !isMandatory;
// }


const TestoRama = () => {
  const {handleAddError, handleRemoveError, submitEnabled, errs, getFormModel, updateFormField, reload} = useMyFormState();
  const [fresh, setFresh] = useState(false);
  const refreshMe  = useCallback(()=>setFresh(prev => !prev), []);

  const [model, setModel] = useState({});

  // const [isUsernameValid, setUsernameValid] = useState(null);
  // const [savedUsername, setSavedUsername]   = useState(null);
  // const [username, setUsername] = useState('');
  // const [email, setEmail]       = useState('');
  // const [savedEmail, setSavedEmail] = useState(null);
  // const [isEmailValid, setEmailValid] = useState(null);

  useEffect(()=>{
    updateFormField('username', 'moshe');
    updateFormField('email', 'mo@she.c');
  }, [updateFormField]);

  useEffect(()=>{
    setModel({...getFormModel()});
    refreshMe();
  }, [reload,getFormModel,refreshMe]);
  
  // const un = getFormModel().username;
  // const em = getFormModel().email;  

  const validateUsername = useCallback((username, isMandatory) => {
    // setUsername(username);
    const result = isValidUsername(username, isMandatory);        
    // setUsernameValid(result);
    return result;
  }, []);

  const validateEmail = useCallback((email, isMandatory) => {
    // setEmail(email);
    const result = isValidEmail(email, isMandatory);
    // setEmailValid(result);
    return result;
  }, []);
  
  const saveUsername = useCallback(async (path, content) => {
    updateFormField(path, content);
    // setSavedUsername(content);
    return isValidUsername(content, true);
  }, [updateFormField]);
  
  const saveEmail = useCallback(async (path, content) => {
    updateFormField(path, content);
    // setSavedEmail(content);
    return isValidEmail(content, true);
  }, [updateFormField]);

  const errPaths  = Object.keys(errs).map(errPath => <TblRow key={errPath}> <TblCell title={errPath}/> </TblRow>)
  const modelRows = Object.entries(getFormModel()).map( ([modelPath, modelValue]) => <TblRow key={modelPath}> <TblCell title={modelPath}/> <TblCell title={modelValue}/>  </TblRow>);


  return (
    <div className='testoRama'>
      <div className='centeron'>
        
        <table>
          <tbody>
            <tr>
              <td width={50}>Username</td>
              <td height={64}>
                <Cell path='username' validateMe={validateUsername} saveMe={saveUsername} addError={handleAddError} removeError={handleRemoveError} isLocked={false} isRequired={true} isSensitive={false} tabIx={1} key='cellUsername'>{model.username}</Cell>
              </td>
            </tr>

            <tr>
              <td>Email</td>
              <td>
                <Cell path='email'    validateMe={validateEmail} saveMe={saveEmail} addError={handleAddError} removeError={handleRemoveError} isLocked={false} isRequired={true} isSensitive={false} tabIx={1} key='cellUsername'>{model.email}</Cell>
              </td>
            </tr>          
          </tbody>
        </table>

        <FormButton isLocked={!submitEnabled} key='testoramaSubmit'> Submit </FormButton>
        <div> </div>
      </div>

      <div className='output'>
        <div className='status'>
          {/* <Tbl>
            <TblHdr cols={['Field', 'Content', 'isValid', 'Last Saved', 'Error', 'isLocked', 'isRequired', 'isSensitive']} />
            <TblRow key='rowUsername'>
              <TblCell title='Username' key='username'/>
              <TblCell title={username} key='usernameVal' />
              <TblCell title={`${isUsernameValid}`} key='isUsernameValidResult' />
              <TblCell title={savedUsername} key='savedUsernameResult' />
              <TblCell title={`${errs['username']}`} key='pathUsername' />
              <TblCell title='false' key='lockedResult' />
              <TblCell title='true' key='requiredResult' />
              <TblCell title='false' key='sensResult' />
            </TblRow>
            <TblRow key='rowEmail'>
              <TblCell title='Email' key='email'/>
              <TblCell title={email} key='emailVal' />
              <TblCell title={`${isEmailValid}`} key='isEmailValidResult' />
              <TblCell title={savedEmail} key='savedEmailResult' />
              <TblCell title={`${errs['email']}`} key='pathEmail' />
              <TblCell title='false' key='lockedResult' />
              <TblCell title='true' key='requiredResult' />
              <TblCell title='false' key='sensResult' />
            </TblRow>
          </Tbl> */}
        </div>

        <div className='errorTable'>
          <Tbl>
            <TblHdr cols={['Error Paths']} />
            <TblRow key='errorPaths'>
              {errPaths}
            </TblRow>
          </Tbl>
        </div>

        <div className='modelTable'>
          <Tbl>
            <TblHdr cols={['Model Path', 'Model Value']} />

              {modelRows}

          </Tbl>
        </div>
      </div>

    </div>
  );
};

export default React.memo(TestoRama);